import React from "react"
import useFetchCenters from "../../hooks/useFetchCenters"

const NavButtons = ({ className, viewMode, setViewMode }) => {
	useFetchCenters()

	return (
		<div className={`flex justify-between items-center w-full ${className}`}>
			{/* View Toggle Buttons */}
			<div className="flex space-x-2">
				<button
					onClick={() => setViewMode("Nursing Acuity")}
					className={`px-4 py-2 rounded-md transition-colors duration-200 ${
						viewMode === "Nursing Acuity"
							? "text-white bg-customBlue"
							: "text-black bg-gray-100 hover:bg-gray-200"
					}`}
				>
					Nursing Acuity
				</button>
				<button
					onClick={() => setViewMode("Nurse Lunch Break")}
					className={`px-4 py-2 rounded-md transition-colors duration-200 ${
						viewMode === "Nurse Lunch Break"
							? "text-white bg-customBlue"
							: "text-black bg-gray-100 hover:bg-gray-200"
					}`}
				>
					Nursing Lunch Break
				</button>
			</div>
		</div>
	)
}

export default NavButtons
